/* import __COLOCATED_TEMPLATE__ from './form.hbs'; */
import Component from '@ember/component';

/**
 *
 *
 * This component renders a text input with phone number formatting.
 *
 * ```
 * <Prism::Form @onSubmit={{this.handleSubmit}} as |form|>
 *  <form.input-text @label="name" @value={{this.firstName}} @onChange={{fn (mut this.phoneNumber)}} />
 *  <form.submit>Sign Up</form.submit>
 * </PrismForm>
 * ```
 *
 * @class Prism::Form
 */
export default Component.extend({
  tagName: '',
  _hasSubmitted: false,
  /**
   * action triggered when the form submits
   *
   * @argument onSubmit
   * @type {Action}
   */
  onSubmit: null,
  /**
   *  when set to true the form will disable all
   * contextual input components and set contextual submit buttons to a
   * "loading" state.
   *
   * @argument isLoading
   * @type {Boolean}
   */
  isLoading: false,
  actions: {
    _onSubmit(event) {
      this.set('_hasSubmitted', true);
      if (this.onSubmit) {
        event && event.preventDefault();
        this.onSubmit(event);
      }
    }
  }
});